// extracted by mini-css-extract-plugin
export default {"linkDivider":"DataTypeLink_linkDivider__1f7MB"};